import { buildUserKey } from './build-user-key';
import { writeEncryptedValue } from './encrypted-values';
import { getKeyPart } from './get-key-part';
import { loginId } from './local-storage-vars';
/**
 * Encrypts the given payload and saves it to the user's localstorage.
 *
 * @param key key to use in localstorage
 * @param payload payload to save in localstorage at [key]
 * @param withKeyPart boolean telling if a localstorage saved random uuid specific to the user
 * should be used as part of the encryption key
 * @returns a promise of false when the payload could not be stored
 */
export function saveForUserEncrypted(key, payload, withKeyPart = false) {
    if (!loginId) {
        return Promise.resolve(false);
    }
    return writeEncryptedValue(buildUserKey(loginId, key), payload, withKeyPart ? getKeyPart(loginId) : loginId);
}
